export const defaultFormatter = (value) => (value === undefined ? '' : String(value));
export const unixTimeFormatter = (value) => (value
    ? `${Math.floor(value)} / ${new Date(value * 1000).toLocaleString().split(', ')[1]}`
    : '');
export const bpsFormatter = (value) => (value === undefined ? '' : `${Math.floor(value / 1000)} kbps`);
export const arrayFormatter = (value) => ((value && value.length > 0) ? value.join(', ') : '');
export const deviceInfoFormatter = (info) => {
    if (!info) {
        return '';
    }
    return arrayFormatter(Object.values(info)
        .filter(Boolean)
        .map((val) => String(val)));
};
export const videoResolutionFormatter = (resolution) => (resolution ? `${resolution.width}x${resolution.height}` : '');
export const bufferLengthFormatter = (buffer) => (buffer ? `Video: ${Math.round(buffer.video * 100) / 100}s, Audio: ${Math.round(buffer.audio * 100) / 100}s` : '');
export const mediaTrackFormatter = (track) => {
    if (!track) {
        return '';
    }
    let trackInfo = track.locale;
    if (track.codec || track.audioFormat) {
        trackInfo += ' (';
        if (track.codec) {
            trackInfo += `${track.codec}`;
        }
        if (track.codec && track.audioFormat) {
            trackInfo += ' - ';
        }
        if (track.audioFormat) {
            trackInfo += `${track.audioFormat}`;
        }
        trackInfo += ')';
    }
    return trackInfo;
};
